import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useMerchantUIContext } from "../MerchantUIContext";
import { useSnackbar } from "notistack";
import { deletePortalMerchant, fetchPortalMerchants, fetchSinglePortalMerchant } from "../../../actions/merchants/merchants";

export function PortalMerchantDeleteDialog({ show, onHide, id }) {
  
  // Products UI Context
  const merchantUIContext = useMerchantUIContext();
  const merchantUIProps = useMemo(() => {
    return {
      ids: id,
      queryParams: merchantUIContext.queryParams,
      setQueryParams: merchantUIContext.setQueryParams,
    };
  }, [merchantUIContext, id]);

  // Products Redux state
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  
  const { merchantName } = useSelector(
    (state) => ({ merchantName: id ? state.merchants?.portalmerchantForEdit?.docs : undefined }),
    shallowEqual
  );

  // if there weren't selected products we should close modal
  useEffect(() => {
    if (!merchantUIProps.ids || merchantUIProps.ids.length === 0) {
      onHide();
    } else {
      dispatch(fetchSinglePortalMerchant(merchantUIProps.ids));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, merchantUIProps.ids]);

  const handledeleteMerchant = () => {
    let query = {
      ...merchantUIProps.queryParams,
      pageNumber: 1,
    }

    // server request for deleting product by seleted ids
    enableLoading();
    dispatch(deletePortalMerchant(id)).then(async (data) => {
      
      onHide();

      await dispatch(fetchPortalMerchants(query));

      merchantUIProps.setQueryParams({
        ...merchantUIProps.queryParams,
        pageNumber: 1,
      })

      await enqueueSnackbar('Merchant deleted successfully', {
        variant: "success",
        autoHideDuration: 4500,
      });

      disableLoading();
    });
  };

  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'>
      {loading}
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>
          Merchant Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <span>Are you sure you want to remove <strong>{merchantName && merchantName.username}</strong> merchant ?</span>
        )}
        {loading && <span>Please wait, Merchant is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'>
            Cancel
          </button>
          <> </>
          <button
            type='button'
            onClick={handledeleteMerchant}
            className='btn btn-primary btn-elevate'
            disabled={loading ? true : false}>
            Delete
            {loading && (
              <span className='ml-3 spinner px-2 spinner-white'></span>
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
